import MessageType from "@/models/Messages/MessageType";

export default class MessageDto {
    id: string;
    tenantId = '';
    createdAt: Date = new Date();
    firebaseUserId: string;
    workerFirebaseUserId: string;
    hasWorkerRead: boolean;
    type: MessageType = MessageType.Public;
    body = '';
    imageUrl = '';
}

// // https://medium.com/swlh/using-firestore-with-typescript-65bd2a602945

// //Generic converter
// const genericConverter = <T>() => ({
//     toFirestore(data: Partial<T>) {
//         return data;
//     },
//     fromFirestore(snapshot: QueryDocumentSnapshot): T {
//         return snapshot.data() as T;
//     }
// });